import React from "react"

function Stats() {
  return (
    <section>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="pb-12 pt-12 md:pb-20 md:pt-20 border-t border-gray-800">
          <div className="shadow-2xl shadow-indigo-500/30 grid md:grid-cols-3 bg-gray-800 divide-y md:divide-y-0 md:divide-x divide-gray-700 px-6 md:px-0 md:py-8 text-center">
            {/* 1st item */}
            <div className="py-6 md:py-0 md:px-8">
              <div
                className="text-4xl font-bold leading-tight tracking-tighter text-purple-600 mb-2"
                data-aos="fade-up"
              >
                20K+
              </div>
              <div
                className="text-lg text-gray-400"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                Filmmakers relied on Filmustage by the end of 2024
              </div>
            </div>
            {/* 2nd item */}
            <div className="py-6 md:py-0 md:px-8">
              <div
                className="text-4xl font-bold leading-tight tracking-tighter text-purple-600 mb-2"
                data-aos="fade-up"
              >
                2.3M+
              </div>
              <div
                className="text-lg text-gray-400"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                Hours of manual work saved by using the Filmustage platform
              </div>
            </div>
            {/* 3rd item */}
            <div className="py-6 md:py-0 md:px-8">
              <div
                className="text-4xl font-bold leading-tight tracking-tighter text-purple-600 mb-2"
                data-aos="fade-up"
              >
                $92M+
              </div>
              <div
                className="text-lg text-gray-400"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                Money saved by using the Filmustage platform
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Stats
